<main
    class="main"
    [agprLoading]="distributionLoading ? false : loading"
    #overlayContainer
>

    @if (distributionDirty) {
        <agpr-scroll-panel>
            <div class="hypePage">
                <div class="hypePage-title">
                    <div class="hypePage-titleImage">
                        <img
                            [src]="appBaseHref + 'assets/images/distributions_personalization.svg'"
                            [alt]="'Discover.distribution.personalize.imageAlt' | localize"
                        />
                    </div>
                    <div class="hypePage-titleText">
                        <h6> {{ 'Discover.distribution.savePersonalization.title' | localize }} </h6>
                    </div>
                </div>
                <div class="hypePage-text">
                    <span> {{ 'Discover.distribution.savePersonalization.body' | localize }} </span>
                </div>
                <agpr-button
                    [id]="id + '_saveDraftButton'"
                    [style]="buttonType.primaryB"
                    label="Discover.targeting.actions.saveDistribution"
                    (click)="saveDistribution.emit()"
                ></agpr-button>
            </div>
        </agpr-scroll-panel>
    } @else if (personalizationOptions.length === 0) {
        <agpr-scroll-panel>
            <div class="hypePage">
                <div class="hypePage-title">
                    <div class="hypePage-titleImage">
                        <img
                            [src]="appBaseHref + 'assets/images/distributions_personalization.svg'"
                            [alt]="'Discover.distribution.personalize.imageAlt' | localize"
                        />
                    </div>
                    <div class="hypePage-titleText">
                        <h6> {{ 'Discover.distribution.noPersonalizations.title' | localize }} </h6>
                        <span> {{ 'Discover.distribution.noPersonalizations.subTitle' | localize }} </span>
                    </div>
                </div>
                <div class="hypePage-text">
                    <ul [attr.aria-label]="'Discover.distribution.noPersonalizations.title' | localize">
                        <li>{{ 'Discover.distribution.noPersonalizations.bullet1' | localize }}</li>
                        <li>{{ 'Discover.distribution.noPersonalizations.bullet2' | localize }}</li>
                        <li>{{ 'Discover.distribution.noPersonalizations.bullet3' | localize }}</li>
                        <li>{{ 'Discover.distribution.noPersonalizations.bullet4' | localize }}</li>
                    </ul>
                </div>
                <div class="learn-more-spacer">
                    <agpr-button
                        [id]="id + '_learnMoreButton'"
                        [style]="buttonType.primaryB"
                        label="Discover.distribution.noPersonalizations.learnMore"
                        (click)="learnMore()"
                    ></agpr-button>
                </div>
            </div>
        </agpr-scroll-panel>

    } @else if (noRecipients) {
        <agpr-scroll-panel>
            <div class="hypePage">
                <div class="hypePage-title">
                    <div class="hypePage-titleImage">
                        <img
                            [src]="appBaseHref + 'assets/images/distributions_personalization.svg'"
                            [alt]="'Discover.distribution.personalize.imageAlt' | localize"
                        />
                    </div>
                    <div class="hypePage-titleText">
                        <h6> {{ 'Discover.distribution.noRecipients.title' | localize }} </h6>
                    </div>
                </div>
                <div class="hypePage-text">
                    <span> {{ 'Discover.distribution.noRecipients.body1' | localize }} </span>
                    <span> {{ 'Discover.distribution.noRecipients.body2' | localize }} </span>
                </div>
                <agpr-button
                    [id]="id + '_addRecipientsButton'"
                    [style]="buttonType.primary"
                    label="Discover.distribution.noRecipients.addRecipients"
                    (click)="navigateToRecipientStep()"
                ></agpr-button>
            </div>
        </agpr-scroll-panel>

    } @else if (unlockedSearches) {
        <agpr-scroll-panel>
            <div class="hypePage">
                <div class="hypePage-title">
                    <div class="hypePage-titleImage">
                        <img
                            [src]="appBaseHref + 'assets/images/distributions_personalization.svg'"
                            [alt]="'Discover.distribution.personalize.imageAlt' | localize"
                        />
                    </div>
                    <div class="hypePage-titleText">
                        <h6> {{ 'Discover.distribution.lockSaveSearches.title' | localize }} </h6>
                    </div>
                </div>
                <div class="hypePage-text">
                    <span> {{ 'Discover.distribution.lockSaveSearches.body1' | localize }} </span>
                    <span> {{ 'Discover.distribution.lockSaveSearches.body2' | localize }} </span>
                </div>
                <div class="hypePage-row">
                    <agpr-button
                        [id]="id + '_editRecipientButton'"
                        [style]="buttonType.secondary"
                        label="Discover.distribution.actions.editRecipient"
                        (click)="navigateToRecipientStep()"
                    ></agpr-button>
                    <agpr-button
                        [id]="id + '_lockAllSavedSearchesButton'"
                        [style]="buttonType.primary"
                        label="Discover.distribution.actions.lockAllSearches"
                        (click)="lockAllSearches()"
                    ></agpr-button>
                </div>
            </div>
        </agpr-scroll-panel>

    } @else if (personalizationOptions.length > 0) {
        <div class="agpr-distributionPersonalize">
            <h4 class="header">
                {{ 'Discover.distribution.personalization' | localize }} -
                <agpr-dropdown
                    class="header-dropdown"
                    [id]="id + '_personalizeDropdown'"
                    [style]="dropdownType.borderless"
                    [options]="personalizationOptions"
                    ariaLabel="Discover.distribution.mergeTagDropdown"
                    [(ngModel)]="selectedPersonalization"
                    (ngModelChange)="onPersonalizationChange($event)"
                    panelStyleClass="agpr-dropdown-panelSocial"
                ></agpr-dropdown>
            </h4>

            <div class="agpr-distributionPersonalize-body">
                <div class="toolbar">
                    <div class="toolbar-row">
                        <div class="filter">
                            <agpr-filter-dropdown
                                class="filterDropdown"
                                [id]="id + '_recipientFilters'"
                                [showQuickFilter]="true"
                                quickFilterPlaceholder="Discover.distribution.personalizeFilter.quickPlaceholder"
                                [ariaLabel]="'Discover.distribution.personalizeFilter.ariaLabel' | localize"
                                [ariaDescribedBy]="id + '_recipientFilters_chips'"
                            ></agpr-filter-dropdown>
                            <div class="filterContainer agpr-distributionPersonalize-filterContainer">
                                <agpr-filter-chips
                                    #filterChipsComponent
                                    [id]="id + '_recipientFilters_chips'"
                                ></agpr-filter-chips>
                                <agpr-button
                                    *ngIf="filterChipsComponent.chips.length > 1"
                                    class="filter--clear"
                                    [style]="buttonType.link"
                                    [id]="id + '_filterClear'"
                                    (click)="clearFilters()"
                                    icon="fa-kit-duotone fa-agpr-remove-all"
                                    tooltip="Monitoring.result.filters.clear"
                                    tooltipPosition="top"
                                ></agpr-button>
                            </div>
                        </div>
                        <agpr-sort-order
                            [id]="id + '_sortOrder'"
                            class="filterSort"
                            [isDisabled]="recipientPersonalizations?.length === 0"
                            optionKey="enumValue"
                            optionLabel="displayString"
                        ></agpr-sort-order>
                    </div>

                    <div class="toolbar-row">
                        <div class="paginator">
                            <div class="paginator-count">
                                <span class="paginator-countBold"> {{ (total | number) || 0 }} </span>
                                <span> {{ 'Discover.distribution.recipients' | localize }} </span>
                            </div>
                            <agpr-paginator
                                [id]="id + '_paginator'"
                                [isDisabled]="recipientPersonalizations?.length === 0"
                            ></agpr-paginator>
                        </div>
                        <agpr-button
                            class="paginator-edit"
                            [id]="id + '_editButton'"
                            [style]="buttonType.icon"
                            icon="fa-regular fa-duotone fa-pen"
                            tooltipPosition="top"
                            tooltip="Discover.distribution.personalization.edit.tooltip"
                            (click)="editFallback()"
                        ></agpr-button>
                        <agpr-button
                            *ngIf="unsavedRecipients > 0"
                            class="paginator-save"
                            [id]="id + '_saveButton'"
                            [style]="buttonType.icon"
                            icon="fa-regular fa-duotone fa-floppy-disk"
                            tooltipPosition="top"
                            tooltip="Discover.distribution.personalization.save.tooltip"
                            (click)="saveAll()"
                        >
                            <span class="paginator-save-recipients"> {{ unsavedRecipients }} </span>
                        </agpr-button>
                    </div>
                    <div class="toolbar-row toolbar-tableHeader">
                        <div class="toolbar-tableHeader-recipient">
                            <span> {{ 'Discover.distribution.recipients' | localize }} </span>
                        </div>
                        <div class="toolbar-row toolbar-tableHeader-system">
                            <span> {{ 'Discover.distribution.system' | localize }} </span>
                            <agpr-button
                                class="toolbar-edit"
                                [id]="id + '_toolbar_editButton'"
                                [style]="buttonType.icon"
                                icon="fa-regular fa-duotone fa-pen"
                                tooltipPosition="top"
                                tooltip="Discover.distribution.personalization.edit.tooltip"
                                (click)="editFallback()"
                            ></agpr-button>
                        </div>
                        <div class="toolbar-tableHeader-custom">
                            <span> {{ 'Discover.distribution.custom' | localize }} </span>
                            <i
                                role="img"
                                class="fa-regular fa-circle-info"
                                [agprTooltip]="'Discover.distribution.personalization.custom.tooltip' | localize : {
                                    personalizationType: (('Discover.personalizationTag.' + selectedPersonalization.value) | localize)
                                }"
                            ></i>
                        </div>
                        <div class="toolbar-tableHeader-save">
                            <agpr-button
                                *ngIf="unsavedRecipients > 0"
                                class="toolbar-save"
                                [id]="id + '_saveButton'"
                                [style]="buttonType.icon"
                                icon="fa-regular fa-duotone fa-floppy-disk"
                                tooltipPosition="top"
                                tooltip="Discover.distribution.personalization.save.tooltip"
                                (click)="saveAll()"
                            >
                                <span class="toolbar-save-recipients"> {{ unsavedRecipients }} </span>
                            </agpr-button>
                        </div>
                    </div>
                </div>
                <agpr-scroll-panel #listViewPanel>
                    <ul class="list">
                        @for (recipientPersonalization of recipientPersonalizations; track recipientPersonalization; let i = $index) {
                            <li>
                                <div
                                    *ngIf="recipientPersonalization.personalization"
                                    class="tuple"
                                    [ngClass]="{'tuple-top': selectedPersonalization.value === personalizationTag.INTRO ||
                                            selectedPersonalization.value === personalizationTag.OUTRO
                                        }"
                                    (agprClickUnless)="cardFocused(recipientPersonalization.recipient)"
                                >
                                    <div
                                        class="card agpr-contextMenu-parent"
                                        [ngClass]="{
                                            'card-focused': selectedRecipientId === recipientPersonalization.recipient.id
                                        }"
                                    >
                                        <img
                                            class="card-img"
                                            [agprImageSrc]="recipientPersonalization.recipient.avatarUrl | twitterAvatarSize:twitterAvatarSize.bigger"
                                            alt=""
                                            [agprDefaultImage]="recipientPersonalization.recipient?.entityType === entityType.CONTACT ?
                                                imageDefault.SMALL_CONTACT : imageDefault.SMALL_OUTLET"
                                        />
                                        <div class="card-content">
                                            <span
                                                [attr.title]="recipientPersonalization.recipient?.entityType === entityType.CONTACT ?
                                                $any(recipientPersonalization.recipient).firstName + ' ' + $any(recipientPersonalization.recipient).lastName :
                                                $any(recipientPersonalization.recipient).name"
                                            >
                                                @if (recipientPersonalization.recipient?.entityType === entityType.CONTACT) {
                                                    {{ $any(recipientPersonalization.recipient).firstName + ' ' + $any(recipientPersonalization.recipient).lastName }}
                                                } @else if (recipientPersonalization.recipient?.entityType === entityType.OUTLET) {
                                                    {{ $any(recipientPersonalization.recipient).name }}
                                                }
                                            </span>

                                            @if (recipientPersonalization.recipient?.entityType === entityType.CONTACT) {
                                                <agpr-button
                                                    [style]="buttonType.link"
                                                    [label]="$any(recipientPersonalization.recipient)?.selectedEmployment?.outlet?.name"
                                                    tooltip="Discover.universal.outletLink.tooltip"
                                                    tooltipPosition="top"
                                                    (click)="focusOutlet(recipientPersonalization.recipient)"
                                                ></agpr-button>
                                            }
                                        </div>
                                        <div class="agpr-contextMenu bottom right">
                                            <agpr-button
                                                class="card-contextMenu-button"
                                                icon="fa-regular fa-duotone fa-pen"
                                                tooltip="Discover.distribution.personalization.editContact.tooltip"
                                                tooltipPosition="top"
                                                (click)="editRecipient(recipientPersonalization.recipient)"
                                                [style]="buttonType.contextMenu"
                                            ></agpr-button>
                                            <agpr-button
                                                class="card-contextMenu-button"
                                                icon="fa-regular fa-duotone fa-eye"
                                                tooltip="Discover.distribution.personalization.preview.tooltip"
                                                tooltipPosition="top"
                                                (click)="viewComponsition(recipientPersonalization.recipient)"
                                                [style]="buttonType.contextMenu"
                                            ></agpr-button>
                                        </div>
                                    </div>
                                    <div class="tuple-container">
                                        <div class="tuple-system">
                                            <span> {{ 'Discover.distribution.system' | localize }} </span>
                                        </div>
                                        <div class="tuple-group">
                                            <agpr-radio
                                                [(ngModel)]="recipientPersonalization.personalization.selectedSource"
                                                (ngModelChange)="updateSelection(recipientPersonalization)"
                                                [value]="personalizationSourceTypeEnum.SYSTEM"
                                            ></agpr-radio>
                                            <div class="tuple-groupCol">
                                                @if (selectedPersonalization.value !== personalizationTag.INTRO &&
                                                    selectedPersonalization.value !== personalizationTag.OUTRO
                                                ) {
                                                    @if (recipientPersonalization.personalization.system.length > 0) {
                                                        <span class="tuple-text">
                                                            {{ recipientPersonalization.personalization.system }}
                                                        </span>
                                                    } @else if (recipientPersonalization.personalization.fallback.length > 0) {
                                                        <span class="tuple-blank">
                                                            {{ recipientPersonalization.personalization.fallback }}
                                                        </span>
                                                    } @else {
                                                        <span class="tuple-blank">
                                                            {{ 'Discover.distribution.editPersonalization.blankField' | localize }}
                                                        </span>
                                                    }
                                                } @else {
                                                    @if (recipientPersonalization.personalization.system.length > 0) {
                                                        <span class="tuple-text">
                                                            <agpr-shadow-dom-container
                                                                [customHtml]="recipientPersonalization.personalization.system"
                                                            ></agpr-shadow-dom-container>
                                                        </span>
                                                    } @else if (recipientPersonalization.personalization.fallback.length > 0) {
                                                        <span class="tuple-text">
                                                            <agpr-shadow-dom-container
                                                                [customHtml]="recipientPersonalization.personalization.fallback"
                                                            ></agpr-shadow-dom-container>
                                                        </span>
                                                    } @else {
                                                        <span class="tuple-blank">
                                                            {{ 'Discover.distribution.editPersonalization.blankField' | localize }}
                                                        </span>
                                                    }
                                                }

                                                @if (recipientPersonalization.personalization.system.length >= MAX_TEXT_COUNT) {
                                                    <agpr-button
                                                        class="tuple-button"
                                                        [style]="buttonType.link"
                                                        label="Discover.distribution.editPersonalization.viewFullText"
                                                        (click)="openPreview(recipientPersonalization.personalization.system, recipientPersonalization.recipient)"
                                                    ></agpr-button>
                                                }
                                            </div>
                                        </div>
                                        <div class="tuple-end">
                                            @if (
                                                recipientPersonalization.personalization.system.length === 0 &&
                                                recipientPersonalization.personalization.selectedSource === personalizationSourceTypeEnum.SYSTEM
                                            ) {
                                                <span
                                                    *ngIf="recipientPersonalization.personalization.fallback.length > 0"
                                                    class="fa solid fa-duotone fa-circle-exclamation tuple--warning"
                                                    agprTooltip="Discover.distribution.editPersonalization.warning"
                                                ></span>
                                                <span
                                                    *ngIf="recipientPersonalization.personalization.fallback.length === 0"
                                                    class="fa solid fa-circle-minus tuple--error"
                                                    agprTooltip="Discover.distribution.editPersonalization.error"
                                                ></span>
                                            }
                                        </div>
                                    </div>
                                    <div class="tuple-container">
                                        <div class="tuple-custom">
                                            <div class="tuple-title">
                                                <span> {{ 'Discover.distribution.custom' | localize }} </span>
                                            </div>
                                            <div class="tuple-tooltip">
                                                <span
                                                    role="img"
                                                    class="fa-regular fa-circle-info"
                                                    [agprTooltip]="'Discover.distribution.personalization.custom.tooltip' | localize : {
                                                        personalizationType: (('Discover.personalizationTag.' + selectedPersonalization.value) | localize)
                                                    }"
                                                ></span>
                                            </div>
                                        </div>
                                        <div
                                            class="tuple-group"
                                            [ngClass]="{
                                                'tuple-group--inputPadded':
                                                    recipientPersonalization.personalization.custom !== recipientPersonalization.personalization.profile &&
                                                    (
                                                        recipientPersonalization.recipient.entityType === entityType.CONTACT && allowedContactProfileSaveTags.includes(recipientPersonalization.personalization.tagType) ||
                                                        recipientPersonalization.recipient.entityType === entityType.OUTLET && allowedOutletProfileSaveTags.includes(recipientPersonalization.personalization.tagType)
                                                    ) || (
                                                        recipientPersonalization.personalization.custom.length === 0 &&
                                                        recipientPersonalization.personalization.selectedSource === personalizationSourceTypeEnum.CUSTOM
                                                    ),
                                                'tuple-group--inputPaddedExtra':
                                                    recipientPersonalization.personalization.custom !== recipientPersonalization.personalization.profile &&
                                                    (
                                                        recipientPersonalization.recipient.entityType === entityType.CONTACT && allowedContactProfileSaveTags.includes(recipientPersonalization.personalization.tagType) ||
                                                        recipientPersonalization.recipient.entityType === entityType.OUTLET && allowedOutletProfileSaveTags.includes(recipientPersonalization.personalization.tagType)
                                                    ) && (
                                                        recipientPersonalization.personalization.custom.length === 0 &&
                                                        recipientPersonalization.personalization.selectedSource === personalizationSourceTypeEnum.CUSTOM
                                                    )
                                            }"
                                        >
                                            <agpr-radio
                                                [(ngModel)]="recipientPersonalization.personalization.selectedSource"
                                                (ngModelChange)="updateSelection(recipientPersonalization)"
                                                [value]="personalizationSourceTypeEnum.CUSTOM"
                                            ></agpr-radio>
                                            @if (selectedPersonalization.value !== personalizationTag.INTRO &&
                                                selectedPersonalization.value !== personalizationTag.OUTRO
                                            ) {
                                                <agpr-text-input
                                                    [placeholder]="'Discover.distribution.personalization.custom.tooltip' | localize : {
                                                        personalizationType: (('Discover.personalizationTag.' + selectedPersonalization.value) | localize)
                                                    }"
                                                    [bottomMargin]="false"
                                                    [(ngModel)]="recipientPersonalization.personalization.custom"
                                                    (blur)="customChange(recipientPersonalization)"
                                                    (focus)="switchToCustom(recipientPersonalization)"
                                                ></agpr-text-input>
                                            } @else {
                                                <div class="tuple-groupCol">
                                                    @if (recipientPersonalization.personalization.custom.length > 0) {
                                                        <div class="tuple-text">
                                                            <agpr-shadow-dom-container
                                                                [customHtml]="recipientPersonalization.personalization.custom"
                                                            ></agpr-shadow-dom-container>
                                                        </div>
                                                    } @else {
                                                        <span class="tuple-blank">
                                                            @if (selectedPersonalization.value === personalizationTag.INTRO) {
                                                                {{ 'Discover.distribution.editPersonalization.noIntro' | localize }}
                                                            } @else {
                                                                {{ 'Discover.distribution.editPersonalization.noOutro' | localize }}
                                                            }
                                                        </span>
                                                    }
                                                    @if (recipientPersonalization.personalization.custom.length >= MAX_TEXT_COUNT) {
                                                        <agpr-button
                                                            class="tuple-button"
                                                            [style]="buttonType.link"
                                                            label="Discover.distribution.editPersonalization.viewFullText"
                                                            (click)="openPreview(recipientPersonalization.personalization.custom, recipientPersonalization.recipient)"
                                                        ></agpr-button>
                                                    }
                                                </div>
                                            }

                                            <div class="tuple-endFloat">
                                                @if (
                                                    recipientPersonalization.personalization.custom.length === 0 &&
                                                    recipientPersonalization.personalization.selectedSource === personalizationSourceTypeEnum.CUSTOM
                                                ) {
                                                    <span
                                                        class="fa solid fa-circle-minus tuple--error"
                                                        [ngClass]="{'tuple--errorTop': selectedPersonalization.value === personalizationTag.INTRO ||
                                                                        selectedPersonalization.value === personalizationTag.OUTRO}"
                                                        agprTooltip="Discover.distribution.editPersonalization.error"
                                                    ></span>
                                                }

                                                @if (recipientPersonalization.personalization.custom !== recipientPersonalization.personalization.profile &&
                                                    (
                                                        recipientPersonalization.recipient.entityType === entityType.CONTACT && allowedContactProfileSaveTags.includes(recipientPersonalization.personalization.tagType) ||
                                                        recipientPersonalization.recipient.entityType === entityType.OUTLET && allowedOutletProfileSaveTags.includes(recipientPersonalization.personalization.tagType)
                                                    )
                                                ) {
                                                    <agpr-button
                                                        class="tuple--save"
                                                        [id]="id + '_saveButton'"
                                                        [style]="buttonType.icon"
                                                        icon="fa-regular fa-duotone fa-floppy-disk"
                                                        tooltipPosition="top"
                                                        tooltip="Discover.distribution.personalization.save.tooltip"
                                                        (click)="saveToProfile(recipientPersonalization)"
                                                    ></agpr-button>
                                                }
                                            </div>


                                        </div>
                                        <div
                                            class="tuple-end"
                                            *ngIf="selectedPersonalization.value === personalizationTag.INTRO ||
                                                selectedPersonalization.value === personalizationTag.OUTRO"
                                        >
                                            <agpr-button
                                                [id]="id + '_aiButton'"
                                                class="tuple--aiButton"
                                                [style]="buttonType.icon"
                                                icon="fa-regular fa-duotone fa-pen"
                                                tooltipPosition="top"
                                                [tooltip]="selectedPersonalization.value === personalizationTag.INTRO ?
                                                    'Discover.distribution.editPersonalizationIntro.tooltip': 'Discover.distribution.editPersonalizationOutro.tooltip'"
                                                (click)="aiRefinement(selectedPersonalization.value, recipientPersonalization)"
                                            ></agpr-button>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        }
                    </ul>
                </agpr-scroll-panel>
            </div>
        </div>
    }
</main>
